import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { useTranslation } from "react-i18next"
import { PhonePlus } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { CONSULT_QUEUES, useConsultActions } from "@/modules/telephony/hooks/useConsultActions"
import { Country, Language } from "@/types/__generated__/union-types"

type ConsultActionButtonsProps = {
  country: Country
  patientLanguage: Language
  patientId?: string
  phoneNumbers: ReadonlyArray<string | null | undefined>
}

const ConsultActionButtons = (props: ConsultActionButtonsProps) => (
  <ErrorBoundary fallback={null}>
    <Suspense fallback={null}>
      <GenesysConsultActionButtons {...props} />
    </Suspense>
  </ErrorBoundary>
)

const GenesysConsultActionButtons = ({
  country,
  patientLanguage,
  patientId,
  phoneNumbers,
}: ConsultActionButtonsProps) => {
  const { t } = useTranslation()
  const { isGenesysCallEnabled, consultQueue, isConsultInFlight, queueBeingConsulted } = useConsultActions(
    country,
    patientLanguage,
    patientId,
    phoneNumbers,
  )

  if (!isGenesysCallEnabled) return null

  return (
    <div className="flex gap-2">
      {CONSULT_QUEUES.map((descriptor) => (
        <Button
          key={descriptor.queue}
          type="button"
          variant="secondary"
          className="pr-6 pl-4"
          data-testid={descriptor.testId}
          disabled={isConsultInFlight}
          isLoading={isConsultInFlight && queueBeingConsulted === descriptor.queue}
          onClick={() => consultQueue(descriptor)}>
          <PhonePlus size={24} />
          {t(descriptor.translationKey)}
        </Button>
      ))}
    </div>
  )
}

export { ConsultActionButtons }
